<app-breadcrumb></app-breadcrumb>
<div class="container mt-4 ">
  <mat-card class="mat-elevation-z8 p-4 cardWithShadow">
    <h3 class="text-center mb-3" style="margin-bottom: 30px; margin-top: 20px;">QR Code Generator</h3>


    <div class="row">
      <!-- First Dropdown (Table Selection) -->
      <span class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Select a Table</mat-label>
          <mat-select [(ngModel)]="selectedTable" (selectionChange)="onTableSelect($event)">
            <mat-option *ngFor="let table of allTables" [value]="table">
              {{ table.nameEn }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>


      <!-- Second Dropdown (Fetched NameEn values) -->
      <span class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100" *ngIf="fetchedNames.length > 0">
          <mat-label>Select an Item</mat-label>
          <mat-select [(ngModel)]="selectedName" (selectionChange)="generateQr()">
            <mat-option *ngFor="let name of fetchedNames" [value]="name">
              {{ name.nameEn }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>

  </mat-card>
</div>

<!-- QR Code Section -->


<div class="container mt-4" >
  <div class="justify-content-center align-items-center d-flex" *ngIf="loading">
    <mat-spinner></mat-spinner>
</div>

  <mat-card class="mat-elevation-z8 p-4 text-center" *ngIf="!loading && qrCodeImageUrl">
    <!-- QR Code Display -->
     <ng-container>
    <div class="d-flex flex-column justify-content-center align-items-center ">
      <img [src]="qrCodeImageUrl" alt="QR Code" class="img-fluid" style="width: 250px; height: 250px;" />
    </div>

    <input type="text" matInput disabled [value]="encryptedurl" />
    <button mat-raised-button color="accent" (click)="printQr()">
      <mat-icon>print</mat-icon> Print
    </button>
  </ng-container>
  </mat-card>
</div>